export const pdpLabels = {
  ProductDetailPage: {
    PDP_Sub: {
      lbl_pdp_pla_abtest: 'Check out these similar styles!',
      lbl_you_may_also_like: 'You May Also Like',
      lbl_recently_viewed: 'People Also Purchased',
      lbl_back_to_results: 'Back To Results',
      lbl_you_recently_viewed: 'RECENTLY VIEWED',
      lbl_modalOffer_detail_heading_text: 'See Similar Products',
      lbl_department: 'Department',
    },
  },
  PLP: {
    plpTiles: {
      lbl_page_not_found: 'Page Not Found',
      lbl_plp_also_available_in: 'ALSO AVAILABLE IN',
      lbl_size_unavailable_online: 'Size unavailable online?',
      lbl_other_sizes_available: 'Other Sizes Available',
    },
  },
  global: {
    Sorting: {
      lbl_TCPBazaarVoiceRating: 'Top Rated',
      lbl_favoritedcount: 'Most Favorited',
    },
    CommonBrowseLabels: {
      lbl_best_seller: 'TRENDING NOW',
    },
  },
};

export const PdpSub = 'ProductDetailPage.PDP_Sub';
export const CmnBrowse = 'global.CommonBrowseLabels';
